/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PoliciesModule
 */

/**
 * @fileoverview Contains Ajs dependency tokens for policy related things.
 * @author Akul Aggarwal
 */

export const BOT_MAPPING_RULE_MATCH_TARGET_CONFIG_ITEM_TOKEN =
'BotMappingRuleMatchTargetConfigItem';

/**
 * Ajs dependency token for NatPolicyCollection.
 */
export const NAT_POLICY_COLLECTION_TOKEN = 'NatPolicyCollection';

export const RESPONSE_MATCH_TARGET_CONFIG_ITEM_TOKEN = 'ResponseMatchTargetConfigItem';
